// extracted by mini-css-extract-plugin
module.exports = {"container":"CurrentPlace--container--3z1YI"};